import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { TeamMembers } from 'common-front/src/teams/teamMembers';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { PositionsSlotId } from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import * as React from 'react';
import { useAssignmentContext } from './assignmentContext';

interface IAssignmentSlotTeamMembersProps {
    positionSlotId: PositionsSlotId;
}

export const AssignmentSlotTeamMembers = (props: IAssignmentSlotTeamMembersProps) => {
    const { translate } = useHeavent();
    const { isPreAssign, teams } = useAssignmentContext();
    const teamMembers = React.useMemo(() => {
        if (!isPreAssign && isNonEmptyArray(teams)) {
            return teams.flatMap((team) =>
                team.members.flatMap((tm) => {
                    const positionsSlotsIds = tm.positionsSlotsUsersInfos.map(
                        (psui) => psui.positionSlotId
                    );
                    const isAlsoSelected = positionsSlotsIds.includes(props.positionSlotId);

                    return isAlsoSelected ? [tm.userInfo] : [];
                })
            );
        } else {
            return [];
        }
    }, [isPreAssign, teams, props.positionSlotId]);

    return isNonEmptyArray(teamMembers) ? (
        <Flex align="center" css={{ marginLeft: 'auto' }} gap="1">
            <TeamMembers teamMembers={teamMembers} />

            <Box font="gray800 textXs regular">
                {translate('_1_quipier_es_00024', teamMembers.length)}
            </Box>
        </Flex>
    ) : null;
};
